import { credentialFormConfigSchema } from '../../../backend/extraTypes';
import { z } from 'zod';
export const getOccupationConfigParamsSchema = z.object({
    occupationId: z.string().min(1),
});
export const getOccupationFormConfigFunctionDef = {
    name: 'getOccupationFormConfig',
    requestSchema: getOccupationConfigParamsSchema,
    responseSchema: credentialFormConfigSchema.array(),
};
